@if (featuresFormGroup) {
    <div class="mb-3">
        <div class="d-flex align-items-center gap-2 mb-2">
            <mat-slide-toggle [formControl]="showFooterControl"> Show Footer </mat-slide-toggle>
        </div>

        @if (showFooterControl.value) {
            <div class="row align-items-center mb-2">
                <div class="col-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Footer Company Logo URL</mat-label>
                        <input
                            matInput
                            id="footer-company-logo"
                            [formControl]="footerCompanyLogoControl"
                            aria-label="Footer Company Logo URL"
                        />
                    </mat-form-field>
                </div>
                <div class="col-6 d-flex align-items-center">
                    <input
                        class="mb-3"
                        id="footer-logo-file"
                        type="file"
                        (change)="onFileSelected($event)"
                        accept=".svg,.png,.jpg"
                    />
                    @if (isUploadingFooterLogo) {
                        <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
                    }
                </div>
            </div>

            <div class="mb-2">
                <h5>Footer Sections</h5>
                @if (footerSectionsArray?.length === 0) {
                    <p class="text-muted">No footer sections. Add one to begin.</p>
                }

                @for (section of footerSectionsArray?.controls; let i = $index; track i) {
                    <mat-divider></mat-divider>
                    <div class="d-flex justify-content-between align-items-center mt-2">
                        <mat-form-field appearance="outline" class="flex-grow-1 me-2">
                            <mat-label>Section Title</mat-label>
                            <input
                                matInput
                                id="section-title-{{ i }}"
                                [formControl]="getSectionTitleControl(section)"
                            />
                        </mat-form-field>
                        <button mat-icon-button color="warn" type="button" (click)="removeSection(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

                    <div class="mt-2">
                        @for (elCtrl of getSectionElementsArray(section).controls; let j = $index; track j) {
                            <div class="d-flex gap-2 align-items-center">
                                <mat-form-field appearance="outline" class="w-25">
                                    <mat-label>Type</mat-label>
                                    <mat-select [formControl]="elCtrl.controls.type">
                                        <mat-option value="text">Text</mat-option>
                                        <mat-option value="email">Email</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="flex-grow-1">
                                    <mat-label>Message</mat-label>
                                    <input
                                        matInput
                                        id="section-{{ i }}-element-{{ j }}-message"
                                        [formControl]="elCtrl.controls.message"
                                    />
                                </mat-form-field>
                                <button mat-icon-button color="warn" type="button" (click)="removeElement(i, j)">
                                    <mat-icon>remove</mat-icon>
                                </button>
                            </div>
                        }
                        <div>
                            <button mat-button color="primary" type="button" (click)="addElement(i)">
                                Add Element
                            </button>
                        </div>
                    </div>
                }

                <div class="mt-2">
                    <button mat-raised-button color="primary" type="button" (click)="addSection()">Add Section</button>
                </div>
            </div>
        }
    </div>
}
